module.exports = __webpack_public_path__ + "static/media/icon_box.1a3e05fe.png";